import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('airwallex_batch_payment_processing_is_underway'),
    description: defineMessage('we_are_currently_verify__this_may_take_a_moment'),
};
